import { render, staticRenderFns } from "./org-tree.vue?vue&type=template&id=c672d4a2"
import script from "./org-tree.vue?vue&type=script&lang=js"
export * from "./org-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c672d4a2')) {
      api.createRecord('c672d4a2', component.options)
    } else {
      api.reload('c672d4a2', component.options)
    }
    module.hot.accept("./org-tree.vue?vue&type=template&id=c672d4a2", function () {
      api.rerender('c672d4a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/org-tree/org-tree.vue"
export default component.exports